import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { guideReturnPath } from "../../components/help/guide-context";
import { GuideSurface } from "../../components/help/GuideSurface";
import { useAuth } from "../../contexts/AuthContext";
import { tenantScope } from "../../lib/tenantScope";

export function BrokerGuidePage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const returnTo = guideReturnPath(location.state, user?.id, tenantScope());
  return (
    <article className="mx-auto w-full max-w-screen-2xl space-y-5 py-4">
      <h1 className="text-navy-950 text-2xl font-semibold">{t("guide.title")}</h1>
      {returnTo && (
        <Link
          className="text-brand-700 inline-flex min-h-11 items-center underline focus-visible:ring-2"
          to={returnTo}
        >
          {t("guide.return")}
        </Link>
      )}
      <GuideSurface />
    </article>
  );
}
